/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import Patient from "core/models/patient";
import PredictorExplainer from "core/models/predictor/predictor-explainer";
export default class ToxicityRiskPredictionScoreResultPageComponent extends Component {
  get explainers() {
    return this.args.patient.toxicityPredictionComputedJournalEvent?.["toxicityExplainers"];
  }
  get scoreDistributionExplainer() {
    return this.explainers?.find(explainer => explainer.explainerType === "score_distribution_plot");
  }
  get shapBarExplainer() {
    return this.explainers?.find(explainer => explainer.explainerType === "explainer_bar_chart");
  }
}